/**
 * @generated SignedSource<<b94a44bf10c57268f27ceeb12cc99f82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceSettingsNameItem_Piece$data = {
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentType": "PieceSettingsNameItem_Piece";
};
export type PieceSettingsNameItem_Piece$key = {
  readonly " $data"?: PieceSettingsNameItem_Piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceSettingsNameItem_Piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceSettingsNameItem_Piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "0dd0342e0e1584d75c0a1b33246eb216";

export default node;
